import { Component } from '@angular/core';
import { PershingTranslationService } from '@pershing/pershing-core';

declare let dojoApp: any;

@Component({
    selector: 'dojo-portfolio-disclaimers',
    templateUrl: './dojo-portfolio-disclaimers.component.html'
})
export class DojoPortfolioDisclaimersComponent {

    constructor(private translationService: PershingTranslationService) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        if (window['require']) {
            let topic = window['require']('dojo/topic');
            let domClass = window['require']('dojo/dom-class');
            let dom = window['require']('dojo/dom');
            topic.subscribe('overview/liabdisclaimer', () => {
                domClass.remove(dom.byId('overview_fdic_disclaimer_l'), 'dijitDisplayNone');
            });
            topic.subscribe('/portfolio/financialPlan', () => {
                if (dom.byId('overview__disclaimer6')) {
                    domClass.remove(dom.byId('overview__disclaimer6'), 'dijitDisplayNone');
                }
            });
        }
    }
}
